import { User } from "@robe/core-types/user";
import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";

/** If `id` param isn't provided current user will be returned */
export const getUser = (core: XcoreCore, id?: number): BaseApiRequest<User> =>
  core.fetch(`/api/user${id ? `/${id}` : ""}`).then((res) => res.json());
